// import React, { useState, useEffect, useCallback } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faUsers } from "@fortawesome/free-solid-svg-icons";
// import { BASE_URL } from "../config";
// import { getAuthHeaders } from "../services/useAuth";
// import Loader from "../dist/Loader";

// const StockistList = () => {
//   const [states, setStates] = useState([]);
//   const [divisions, setDivisions] = useState([]);
//   const [selectedState, setSelectedState] = useState("");
//   const [selectedDivision, setSelectedDivision] = useState("");
//   const [stockists, setStockists] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [allStockists, setAllStockists] = useState([]);
//   const [employeesCache, setEmployeesCache] = useState({});

//   useEffect(() => {
//     fetch(`${BASE_URL}/api/states`, {
//       headers: getAuthHeaders(),
//     })
//       .then((res) => res.json())
//       .then((data) => setStates(data))
//       .catch((error) => console.error("Error fetching states:", error));

//     fetchInitialStockists();
//   }, []);

//   useEffect(() => {
//     if (selectedState) {
//       fetch(`${BASE_URL}/api/divisions?state_id=${selectedState}`, {
//         headers: getAuthHeaders(),
//       })
//         .then((res) => res.json())
//         .then((data) => setDivisions(data))
//         .catch((error) => console.error("Error fetching divisions:", error));
//     } else {
//       setDivisions([]);
//       setSelectedDivision("");
//     }
//   }, [selectedState]);

//   useEffect(() => {
//     updateStockistsWithEmployeeNames();
//   }, [employeesCache]);

// const fetchInitialStockists = useCallback(() => {
//   fetch(`${BASE_URL}/api/stockist/list?purpose=assign&is_application=true`, {
//     headers: getAuthHeaders(),
//   })
//     .then((res) => res.json())
//     .then((data) => {
//       if (Array.isArray(data)) {
//         setAllStockists(data);
//         setStockists(data);
//         prefetchEmployeeData(data);
//       }
//     })
//     .catch((error) => {
//       console.error("Error fetching stockists:", error);
//     });
// }, []);
//   const fetchFilteredStockists = useCallback(() => {
//     setIsLoading(true);

//     let url = `${BASE_URL}/api/stockist/list?purpose=assign&is_application=true&`;
//     const params = new URLSearchParams();

//     if (selectedState) params.append("state_id", selectedState);
//     if (selectedDivision) params.append("division_id", selectedDivision);

//     fetch(url + params.toString(), {
//       headers: getAuthHeaders(),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         if (Array.isArray(data)) {
//           setStockists(data);
//           prefetchEmployeeData(data);
//         } else {
//           setStockists([]);
//         }
//         setIsLoading(false);
//       })
//       .catch((error) => {
//         console.error("Error fetching filtered stockists:", error);
//         setIsLoading(false);
//         setStockists([]);
//       });
//   }, [selectedState, selectedDivision]);

//   const prefetchEmployeeData = useCallback(
//     (stockistList) => {
//       const uniqueEmployeeIds = [
//         ...new Set(
//           stockistList
//             .map((s) => s.employee_id)
//             .filter((id) => id !== null && id !== undefined)
//         ),
//       ];

//       if (uniqueEmployeeIds.length === 0) return;

//       Promise.all(
//         uniqueEmployeeIds.map((id) =>
//           fetch(`${BASE_URL}/api/employees/${id}`, {
//             headers: getAuthHeaders(),
//           })
//             .then((res) => {
//               if (!res.ok) throw new Error(`Failed to fetch employee ${id}`);
//               return res.json();
//             })
//             .then((emp) => {
//               if (!emp) throw new Error(`No employee data for ID ${id}`);
//               return {
//                 id,
//                 name:
//                   emp.first_name && emp.last_name
//                     ? `${emp.first_name} ${emp.last_name}`
//                     : "N/A",
//               };
//             })
//             .catch((error) => {
//               console.error(`Error fetching employee ${id}:`, error);
//               return { id, name: "N/A" };
//             })
//         )
//       )
//         .then((employees) => {
//           const newCache = { ...employeesCache };
//           employees.forEach((emp) => {
//             newCache[emp.id] = emp.name;
//           });
//           setEmployeesCache(newCache);
//         })
//         .catch((error) => {
//           console.error("Error prefetching employee data:", error);
//         });
//     },
//     [employeesCache]
//   );

//   const updateStockistsWithEmployeeNames = useCallback(() => {
//     setStockists((prevStockists) =>
//       prevStockists.map((stockist) => {
//         const nameToShow =
//           stockist.employee_name ||
//           (stockist.employee_id ? employeesCache[stockist.employee_id] : null);
//         return {
//           ...stockist,
//           employee_name: nameToShow || "N/A",
//         };
//       })
//     );

//     setAllStockists((prev) =>
//       prev.map((stockist) => {
//         const nameToShow =
//           stockist.employee_name ||
//           (stockist.employee_id ? employeesCache[stockist.employee_id] : null);
//         return {
//           ...stockist,
//           employee_name: nameToShow || "N/A",
//         };
//       })
//     );
//   }, [employeesCache]);

// const handleFilter = useCallback(() => {
//   fetchFilteredStockists();   
// }, [fetchFilteredStockists]);

//   const handleStateChange = (value) => {
//     setSelectedState(value);
//     setSelectedDivision("");
//   };

//   const handleRemoveStockist = useCallback(
//     async (employee_id, stockist_code) => {
//       if (
//         !window.confirm(
//           "Are you sure you want to unassign this stockist from the employee?"
//         )
//       ) {
//         return;
//       }

//       try {
//         const response = await fetch(`${BASE_URL}/api/stockist/unassign`, {
//           method: "POST",
//           headers: {
//             ...getAuthHeaders(),
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             employee_id: employee_id,
//             stockist_codes: [stockist_code],
//           }),
//         });

//         if (!response.ok) {
//           throw new Error("Failed to unassign stockist");
//         }

//         alert("Stockist unassigned successfully");

//         // ✅ Call list API again so table updates
//         if (selectedState || selectedDivision) {
//           fetchFilteredStockists();
//         } else {
//           fetchInitialStockists();
//         }
//       } catch (error) {
//         console.error("Error unassigning stockist:", error);
//         alert("Failed to unassign stockist. Please try again.");
//       }
//     },
//     [
//       selectedState,
//       selectedDivision,
//       fetchFilteredStockists,
//       fetchInitialStockists,
//     ]
//   );

//   return (
//     <div className="w-full min-h-screen flex flex-col bg-white">
//     {isLoading && (
//           <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/30 backdrop-blur-sm">
//             <Loader onCancel={() => setIsLoading(false)} />
//           </div>
//         )}
//       {/* full width main wrapper */}
//       <div className="w-full">
//         {/* visible gray border wrapper as requested */}
//         <div className="w-full border border-gray-600 rounded-md bg-white">
//           {/* header centered */}
//           <div className="w-full flex justify-center py-6 px-4">
//             <div className="flex items-center gap-3">
//               <FontAwesomeIcon
//                 icon={faUsers}
//                 className="text-blue-600 text-2xl"
//               />
//               <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 text-center">
//                 <span className="text-blue-700">Stockist </span>
//                 <span className="text-blue-500">Employee List</span>
//               </h1>
//             </div>
//           </div>

//           {/* filters centered container, full width with three items in a row (State, Division, GO) */}
//           <div className="w-full flex justify-center">
//             <div className="w-full max-w-5xl">
//               <div className="flex flex-row flex-wrap items-center justify-center gap-6 bg-white p-4 rounded-lg shadow-sm border mb-4">
//                 {/* State (label left of dropdown) */}
//                 <div className="flex items-center gap-2">
//                   <label className="text-sm font-medium text-gray-700 whitespace-nowrap">
//                     State
//                   </label>
//                   <select
//                     value={selectedState}
//                     onChange={(e) => handleStateChange(e.target.value)}
//                     className="min-w-[180px] px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   >
//                     <option value="">All</option>
//                     {states.map((state) => (
//                       <option key={state.id} value={state.id}>
//                         {state.name}
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 {/* Division (label left of dropdown) */}
//                 <div className="flex items-center gap-2">
//                   <label className="text-sm font-medium text-gray-700 whitespace-nowrap">
//                     Division
//                   </label>
//                   <select
//                     value={selectedDivision}
//                     onChange={(e) => setSelectedDivision(e.target.value)}
//                     disabled={!selectedState}
//                     className="min-w-[180px] px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50"
//                   >
//                     <option value="">All</option>
//                     {divisions.map((division) => (
//                       <option key={division.id} value={division.id}>
//                         {division.name}
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 <div className="flex items-center">
//                   <button
//                     onClick={handleFilter}
//                     disabled={isLoading}
//                     className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-md disabled:opacity-60"
//                   >
//                 GO
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="w-full px-4 pb-8">
//               <div className="border rounded shadow  table-wrapper">
//                 <div className="relative">
//                   {stockists.length === 0 ? (
//                     <div className="p-6 text-center text-gray-600">
//                       No stockists found matching your criteria
//                     </div>
//                   ) : (
//                     <table className="unlock-dcr-leave-table text-sm ">
//                       <thead className="bg-blue-500 text-white">
//                         <tr>
//                           <th className="sticky top-0 z-40 bg-blue-500 text-white border px-3 py-2">
//                             S.No
//                           </th>
//                           <th className="sticky top-0 z-40 bg-blue-500 text-white border px-3 py-2">
//                             State
//                           </th>
//                           <th className="sticky top-0 z-40 bg-blue-500 text-white border px-3 py-2">
//                             Stockist Code
//                           </th>
//                           <th className="sticky top-0 z-40 bg-blue-500 text-white border px-3 py-2">
//                             Stockist Name
//                           </th>
//                           <th className="sticky top-0 z-40 bg-blue-500 text-white border px-3 py-2">
//                             City
//                           </th>
//                           <th className="sticky top-0 z-40 bg-blue-500 text-white border px-3 py-2">
//                             Emp ID
//                           </th>
//                           <th className="sticky top-0 z-40 bg-blue-500 text-white border px-3 py-2">
//                             Employee Name
//                           </th>
//                           <th className="sticky top-0 z-40 bg-blue-500 text-white border px-3 py-2">
//                             HQ
//                           </th>
//                           <th className="sticky top-0 z-40 bg-blue-500 text-white border px-3 py-2">
//                             Phone
//                           </th>
//                           <th className="sticky top-0 z-40 bg-blue-500 text-white border px-3 py-2">
//                             DOR
//                           </th>
//                           <th className="sticky top-0 z-40 bg-blue-500 text-white border px-3 py-2">
//                             Added Date
//                           </th>
//                           <th className="sticky top-0 z-40 bg-blue-500 text-white border px-3 py-2">
//                             GSTIN
//                           </th>
//                           <th className="sticky top-0 z-40 bg-blue-500 text-white border px-3 py-2">
//                             Address
//                           </th>
//                           <th className="sticky top-0 z-40 bg-blue-500 text-white border px-3 py-2">
//                             Action
//                           </th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {stockists.map((stockist, index) => (
//                           <tr key={index} className="even:bg-gray-50">
//                             <td className="border px-3 py-2 text-center">
//                               {index + 1}
//                             </td>
//                             <td className="border px-3 py-2 text-center">
//                               {stockist.state_name}
//                             </td>
//                             <td className="border px-3 py-2 text-center">
//                               {stockist.stockist_code}
//                             </td>
//                             <td className="border px-3 py-2 text-center">
//                               {stockist.stockist_name}
//                             </td>
//                             <td className="border px-3 py-2 text-center">
//                               {stockist.city_name}
//                             </td>
//                             <td className="border px-3 py-2 text-center">
//                               {stockist.employee || "N/A"}
//                             </td>
//                             <td className="border px-3 py-2 text-center">
//                               {stockist.employee_name || "N/A"}
//                             </td>
//                             <td className="border px-3 py-2 text-center">
//                               {stockist.headquarter_name ||
//                                 stockist.headquarter_id}
//                             </td>
//                             <td className="border px-3 py-2 text-center">
//                               {stockist.mobile}
//                             </td>
//                             <td className="border px-3 py-2 text-center">
//                               {stockist.dor}
//                             </td>
//                             <td className="border px-3 py-2 text-center">
//                               {stockist.added_date
//                                 ? new Date(
//                                     stockist.added_date
//                                   ).toLocaleDateString("en-GB", {
//                                     day: "numeric",
//                                     month: "short",
//                                     year: "numeric",
//                                   })
//                                 : "N/A"}
//                             </td>
//                             <td className="border px-3 py-2 text-center">
//                               {stockist.gstin}
//                             </td>
//                             <td className="border px-3 py-2 text-center">
//                               {stockist.address}
//                             </td>
//                             <td className="border px-3 py-2 text-center">
//                               {stockist.employee_id && (
//                                 <button
//                                   onClick={() =>
//                                     handleRemoveStockist(
//                                       stockist.employee_id,
//                                       stockist.stockist_code
//                                     )
//                                   }
//                                   className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded"
//                                 >
//                                   Remove
//                                 </button>
//                               )}
//                             </td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   )}
//                 </div>
//               </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default StockistList;


import React, { useState, useEffect, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { BASE_URL } from "../config";
import { getAuthHeaders } from "../services/useAuth";
import Loader from "../dist/Loader";

const StockistList = () => {
  const [states, setStates] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [stockists, setStockists] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [allStockists, setAllStockists] = useState([]);
  const [employeesCache, setEmployeesCache] = useState({});

  useEffect(() => {
    fetch(`${BASE_URL}/api/states`, { headers: getAuthHeaders() })
      .then((res) => res.json())
      .then((data) => setStates(data))
      .catch((error) => console.error("Error fetching states:", error));

    fetchInitialStockists();
  }, []);

  useEffect(() => {
    if (selectedState) {
      fetch(`${BASE_URL}/api/divisions?state_id=${selectedState}`, {
        headers: getAuthHeaders(),
      })
        .then((res) => res.json())
        .then((data) => setDivisions(data))
        .catch((error) => console.error("Error fetching divisions:", error));
    } else {
      setDivisions([]);
      setSelectedDivision("");
      setEmployees([]);
      setSelectedEmployee("");
    }
  }, [selectedState]);

  // Fetch employees whenever state OR division changes
  useEffect(() => {
    if (selectedState) {
      setSelectedEmployee("");
      const params = new URLSearchParams();
      params.append("state_id", selectedState);
      if (selectedDivision) {
        const divisionName = divisions.find(
          (d) => String(d.id) === String(selectedDivision)
        )?.name;
        if (divisionName) params.append("division", divisionName);
      }
      fetch(`${BASE_URL}/api/employees?${params.toString()}`, {
        headers: getAuthHeaders(),
      })
        .then((res) => res.json())
        .then((data) => setEmployees(Array.isArray(data) ? data : []))
        .catch(() => setEmployees([]));
    } else {
      setEmployees([]);
      setSelectedEmployee("");
    }
  }, [selectedState, selectedDivision]);

  useEffect(() => {
    updateStockistsWithEmployeeNames();
  }, [employeesCache]);

  const fetchInitialStockists = useCallback(() => {
    fetch(`${BASE_URL}/api/stockist/list?purpose=assign&is_application=true`, {
      headers: getAuthHeaders(),
    })
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setAllStockists(data);
          setStockists(data);
          prefetchEmployeeData(data);
        }
      })
      .catch((error) => console.error("Error fetching stockists:", error));
  }, []);

  const fetchFilteredStockists = useCallback(() => {
    setIsLoading(true);
    const params = new URLSearchParams();
    params.append("purpose", "assign");
    params.append("is_application", "true");
    if (selectedState) params.append("state_id", selectedState);
    if (selectedDivision) params.append("division_id", selectedDivision);
    if (selectedEmployee) params.append("employee_id", selectedEmployee);

    fetch(`${BASE_URL}/api/stockist/list?${params.toString()}`, {
      headers: getAuthHeaders(),
    })
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setStockists(data);
          prefetchEmployeeData(data);
        } else {
          setStockists([]);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching filtered stockists:", error);
        setIsLoading(false);
        setStockists([]);
      });
  }, [selectedState, selectedDivision, selectedEmployee]);

  const prefetchEmployeeData = useCallback(
    (stockistList) => {
      const uniqueEmployeeIds = [
        ...new Set(
          stockistList
            .map((s) => s.employee_id)
            .filter((id) => id !== null && id !== undefined)
        ),
      ];
      if (uniqueEmployeeIds.length === 0) return;

      Promise.all(
        uniqueEmployeeIds.map((id) =>
          fetch(`${BASE_URL}/api/employees/${id}`, { headers: getAuthHeaders() })
            .then((res) => {
              if (!res.ok) throw new Error(`Failed to fetch employee ${id}`);
              return res.json();
            })
            .then((emp) => ({
              id,
              name:
                emp.first_name && emp.last_name
                  ? `${emp.first_name} ${emp.last_name}`
                  : "N/A",
            }))
            .catch(() => ({ id, name: "N/A" }))
        )
      )
        .then((emps) => {
          const newCache = { ...employeesCache };
          emps.forEach((emp) => { newCache[emp.id] = emp.name; });
          setEmployeesCache(newCache);
        })
        .catch((error) => console.error("Error prefetching employee data:", error));
    },
    [employeesCache]
  );

  const updateStockistsWithEmployeeNames = useCallback(() => {
    const updater = (list) =>
      list.map((stockist) => ({
        ...stockist,
        employee_name:
          stockist.employee_name ||
          (stockist.employee_id ? employeesCache[stockist.employee_id] : null) ||
          "N/A",
      }));
    setStockists((prev) => updater(prev));
    setAllStockists((prev) => updater(prev));
  }, [employeesCache]);

  const handleFilter = useCallback(() => {
    fetchFilteredStockists();
  }, [fetchFilteredStockists]);

  const handleStateChange = (value) => {
    setSelectedState(value);
    setSelectedDivision("");
    setSelectedEmployee("");
  };

  const handleRemoveStockist = useCallback(
    async (employee_id, stockist_code) => {
      if (!window.confirm("Are you sure you want to unassign this stockist from the employee?")) return;
      try {
        const response = await fetch(`${BASE_URL}/api/stockist/unassign`, {
          method: "POST",
          headers: { ...getAuthHeaders(), "Content-Type": "application/json" },
          body: JSON.stringify({ employee_id, stockist_codes: [stockist_code] }),
        });
        if (!response.ok) throw new Error("Failed to unassign stockist");
        alert("Stockist unassigned successfully");
        if (selectedState || selectedDivision || selectedEmployee) {
          fetchFilteredStockists();
        } else {
          fetchInitialStockists();
        }
      } catch (error) {
        console.error("Error unassigning stockist:", error);
        alert("Failed to unassign stockist. Please try again.");
      }
    },
    [selectedState, selectedDivision, selectedEmployee, fetchFilteredStockists, fetchInitialStockists]
  );

  return (
    <div className="w-full min-h-screen flex flex-col bg-white">
      {isLoading && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/30 backdrop-blur-sm">
          <Loader onCancel={() => setIsLoading(false)} />
        </div>
      )}

      <div className="w-full">
        <div className="w-full border border-gray-600 rounded-md bg-white">

          {/* Header */}
          <div className="w-full flex justify-center py-6 px-4">
            <div className="flex items-center gap-3">
              <FontAwesomeIcon icon={faUsers} className="text-blue-600 text-2xl" />
              <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 text-center">
                <span className="text-blue-700">Stockist </span>
                <span className="text-blue-500">Employee List</span>
              </h1>
            </div>
          </div>

          {/* Filter row — identical style to original, employee dropdown added */}
          <div className="w-full flex justify-center">
            <div className="w-full max-w-5xl">
              <div className="flex flex-row flex-wrap items-center justify-center gap-6 bg-white p-4 rounded-lg shadow-sm border mb-4">

                {/* State */}
                <div className="flex items-center gap-2">
                  <label className="text-sm font-medium text-gray-700 whitespace-nowrap">State</label>
                  <select
                    value={selectedState}
                    onChange={(e) => handleStateChange(e.target.value)}
                    className="min-w-[180px] px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="">All</option>
                    {states.map((state) => (
                      <option key={state.id} value={state.id}>{state.name}</option>
                    ))}
                  </select>
                </div>

                {/* Division */}
                <div className="flex items-center gap-2">
                  <label className="text-sm font-medium text-gray-700 whitespace-nowrap">Division</label>
                  <select
                    value={selectedDivision}
                    onChange={(e) => {
                      setSelectedDivision(e.target.value);
                      setSelectedEmployee("");
                    }}
                    disabled={!selectedState}
                    className="min-w-[180px] px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50"
                  >
                    <option value="">All</option>
                    {divisions.map((division) => (
                      <option key={division.id} value={division.id}>{division.name}</option>
                    ))}
                  </select>
                </div>

                {/* Employee — NEW, same style */}
                <div className="flex items-center gap-2">
                  <label className="text-sm font-medium text-gray-700 whitespace-nowrap">Employee</label>
                  <select
                    value={selectedEmployee}
                    onChange={(e) => setSelectedEmployee(e.target.value)}
                    disabled={!selectedState}
                    className="w-[320px] px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50"                  >
                    <option value="">All</option>
                    {employees.map((emp) => (
                      <option key={emp.id} value={emp.id}>
                        {emp.first_name} {emp.last_name}
                        {emp.employee_code ? ` (${emp.employee_code})` : ""}
                        {emp.division ? ` | ${emp.division}` : ""}
                        {emp.designation ? ` | ${emp.designation}` : ""}
                      </option>
                    ))}
                  </select>
                </div>

                {/* GO */}
                <div className="flex items-center">
                  <button
                    onClick={handleFilter}
                    disabled={isLoading}
                    className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-md disabled:opacity-60"
                  >
                    GO
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Table — exactly as original */}
          <div className="w-full px-4 pb-8">
            <div className="border rounded shadow table-wrapper">
              <div className="relative">
                {stockists.length === 0 ? (
                  <div className="p-6 text-center text-gray-600">
                    No stockists found matching your criteria
                  </div>
                ) : (
                  <table className="unlock-dcr-leave-table text-sm">
                    <thead className="bg-blue-500 text-white">
                      <tr>
                        {["S.No", "State", "Stockist Code", "Stockist Name", "City", "Emp ID", "Employee Name", "HQ", "Phone", "DOR", "Added Date", "GSTIN", "Address", "Action"].map((h) => (
                          <th key={h} className="sticky top-0 z-40 bg-blue-500 text-white border px-3 py-2">{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {stockists.map((stockist, index) => (
                        <tr key={index} className="even:bg-gray-50">
                          <td className="border px-3 py-2 text-center">{index + 1}</td>
                          <td className="border px-3 py-2 text-center">{stockist.state_name}</td>
                          <td className="border px-3 py-2 text-center">{stockist.stockist_code}</td>
                          <td className="border px-3 py-2 text-center">{stockist.stockist_name}</td>
                          <td className="border px-3 py-2 text-center">{stockist.city_name}</td>
                          <td className="border px-3 py-2 text-center">{stockist.employee || "N/A"}</td>
                          <td className="border px-3 py-2 text-center">{stockist.employee_name || "N/A"}</td>
                          <td className="border px-3 py-2 text-center">{stockist.headquarter_name || stockist.headquarter_id}</td>
                          <td className="border px-3 py-2 text-center">{stockist.mobile}</td>
                          <td className="border px-3 py-2 text-center">{stockist.dor}</td>
                          <td className="border px-3 py-2 text-center">
                            {stockist.added_date
                              ? new Date(stockist.added_date).toLocaleDateString("en-GB", {
                                day: "numeric", month: "short", year: "numeric",
                              })
                              : "N/A"}
                          </td>
                          <td className="border px-3 py-2 text-center">{stockist.gstin}</td>
                          <td className="border px-3 py-2 text-center">{stockist.address}</td>
                          <td className="border px-3 py-2 text-center">
                            {stockist.employee_id && (
                              <button
                                onClick={() => handleRemoveStockist(stockist.employee_id, stockist.stockist_code)}
                                className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded"
                              >
                                Remove
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default StockistList;